<template>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 9.49609C8.82843 9.49609 9.5 8.82452 9.5 7.99609C9.5 7.16767 8.82843 6.49609 8 6.49609C7.17157 6.49609 6.5 7.16767 6.5 7.99609C6.5 8.82452 7.17157 9.49609 8 9.49609Z"
      fill="#868D9C"
    />
    <path
      d="M8.01172 9.35547V14.4971"
      stroke="#868D9C"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.01262 5.07031L3.34321 8.03905C3.30837 8.10952 3.29358 8.18822 3.30048 8.26654C3.30738 8.34485 3.33568 8.41975 3.38231 8.48305L8.01189 14.4966L12.6409 8.48305C12.6876 8.41975 12.7159 8.34485 12.7228 8.26654C12.7297 8.18822 12.7149 8.10952 12.68 8.03905L11.0112 5.07031H5.01262Z"
      stroke="#868D9C"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.0122 5.0708V2.92847C11.0122 2.81483 10.9671 2.70585 10.8867 2.62549C10.8064 2.54514 10.6974 2.5 10.5837 2.5H5.44214C5.3285 2.5 5.21952 2.54514 5.13917 2.62549C5.05881 2.70585 5.01367 2.81483 5.01367 2.92847V5.0708"
      stroke="#868D9C"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
